import * as React from 'react';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  DeleteButton,
  TextInput,
  NumberField,
  NumberInput,
  BooleanField,
  BooleanInput,
  SelectInput,
  SelectField,
  required,
  useTranslate,
} from 'react-admin';

import EmptyList from '../components/misc/EmptyList';

const entity = 'settlementCategories';

const KIND_CHOICES = [
  { id: 'income', name: 'Gelir (Income)' },
  { id: 'expense', name: 'Gider (Expense)' },
  { id: 'both', name: 'Her ikisi' },
];

export const SettlementCategoryList = (props) => {
  const translate = useTranslate();

  return (
    <List
      {...props}
      empty={<EmptyList entity={entity} />}
      title={translate('menu.accountancy_items', { _: 'Muhasebe Kalemleri' })}
      exporter={false}
      sort={{ field: 'order', order: 'ASC' }}
    >
      <Datagrid bulkActionButtons={false} rowClick="edit">
        <TextField source="name" label="Ad" />
        <SelectField source="kind" label="Tip" choices={KIND_CHOICES} />
        <TextField source="code" label="Kod" />
        <NumberField source="order" label="Sıra" />
        <BooleanField source="isActive" label="Aktif?" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};

const CategoryForm = () => (
  <SimpleForm>
    <TextInput source="name" label="Ad" fullWidth validate={required()} />
    <SelectInput
      source="kind"
      label="Tip"
      choices={KIND_CHOICES}
      defaultValue="both"
      fullWidth
      validate={required()}
    />
    <TextInput
      source="code"
      label="Kod (opsiyonel)"
      fullWidth
      helperText="Örn: advertisement, subscription"
    />
    <NumberInput source="order" label="Sıra" fullWidth defaultValue={0} />
    <BooleanInput source="isActive" label="Aktif?" defaultValue={true} />
    <TextInput source="notes" label="Not" fullWidth multiline minRows={2} />
  </SimpleForm>
);

export const SettlementCategoryEdit = (props) => (
  <Edit title="Kalem Düzenle" {...props} redirect="list">
    <CategoryForm />
  </Edit>
);

export const SettlementCategoryCreate = (props) => (
  <Create title="Yeni Kalem" {...props} redirect="list">
    <CategoryForm />
  </Create>
);
